import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  exportTableData: {},
  isMapDataLoading: false,
  poiImageData: ''
}

const exportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {
    setExportTableData: (state, action) => {
      state.exportTableData = action.payload
    },
    setIsMapDataLoading: (state, action) => {
      state.isMapDataLoading = action.payload
    },
    setPoiImageData: (state, action) => {
      state.poiImageData = action.payload
    }
  }
})

export const {setExportTableData, setIsMapDataLoading, setPoiImageData} = exportSlice.actions

export const selectExportTableData = (state) => state.export?.exportTableData ?? {}
export const selectIsMapDataLoading = (state) => state.export?.isMapDataLoading ?? false
export const selectPoiImageData = (state) => state.export?.poiImageData ?? ''

export default exportSlice.reducer
